import React, { useState } from "react";
import CuInput from "../../all-patient/components/CuInput";
import { IoAdd, IoClose } from "react-icons/io5";
import CuSpinner from "../../common_component/component/CuSpinner";
import { dummy_data } from "../_constant";
import { toast } from "react-toastify";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import {
  useCreateItem,
  useSecureDeleteItem,
} from "../../_helper/actions/mutation/items";
import { useAtom } from "jotai";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { useCurrentRole } from "../../_helper/constant/Permission";
import { useItemsFilterNew } from "../../_helper/actions/app/items";

export default function CreateCertificateForm({
  setSelectedForm,
  selectedForm,
}) {
  const [isCreate, setIsCreate] = useState(false);
  const [formTitle, setFormTitle] = useState("");
  const [formList, setFormList] = useState([]);
  const [clinic] = useAtom(clinicAtom);
  const [deleteId, setDeleteId] = useState(null);
  const { role_id } = useCurrentRole();

  const postFormMutation = useCreateItem(ApiEndPoint.CLINIC);
  const deleteFormMutation = useSecureDeleteItem(ApiEndPoint.CLINIC);

  const handleGetForms = (response) => {
    setFormList(response.data || []);
  };

  const { data: forms } = useItemsFilterNew(
    ApiEndPoint.CLINIC,
    `?action=getCertificate&clinic_id=${clinic?.id}&backend=True`,
    clinic?.id ? true : false,
    handleGetForms
  );

  const handleFormTitle = (e) => {
    setFormTitle(e.target.value);
  };

  const handleCreateForm = () => {
    setIsCreate((prev) => !prev);
  };

  const handleSelectForm = (form) => {
    // console.log(form);
    setSelectedForm(form);
  };

  const handleAddForm = () => {
    if (formTitle?.length > 0) {
      const newForm = {
        action: "postCertificate",
        backend: "True",
        clinic_id: clinic?.id,
        name: formTitle,
        doctor_user: role_id,
        // section: [1],
      };
      postFormMutation.mutate(newForm, {
        onSuccess: (response) => {
          setFormList((prev) => {
            const newForm = {
              ...response?.data,
            };
            return [...prev, newForm];
          });
          setIsCreate(false);
          setFormTitle("");
        },
        onError: (err) => toast.error(JSON.stringify(err)),
      });
    } else {
      toast.error("Please Enter Certificate Name");
    }
  };

  const handleDeleteForm = (e, id) => {
    if (id) {
      setDeleteId(id);
      const deleteForm = {
        action: "delCertificate",
        backend: "True",
        clinic_id: clinic?.id,
        id: id,
      };
      deleteFormMutation.mutate(deleteForm, {
        onSuccess: () => {
          setFormList((prev) => {
            const temp = prev?.filter((ele) => ele?.id !== id);
            return temp;
          });
          setDeleteId(null);
          if (id === selectedForm?.id) {
            setSelectedForm(null);
          }
        },
        onError: (err) => {
          setDeleteId(null);
          toast.error(JSON.stringify(err));
        },
      });
    }
    e.stopPropagation();
  };

  return (
    <div className="w-[20%] border p-2 border-[#C9C9C9] rounded flex flex-col gap-2">
      {!isCreate && (
        <div
          className="w-full h-12 cursor-pointer rounded border border-dashed border-[#C9C9C9] flex justify-center items-center"
          onClick={handleCreateForm}
        >
          + Create New
        </div>
      )}

      {isCreate && (
        <div className="flex items-center gap-1">
          <div className="flex-1">
            <CuInput onChange={handleFormTitle} value={formTitle} />
          </div>
          <div className="flex items-center gap-1">
            {postFormMutation.isLoading ? (
              <CuSpinner />
            ) : (
              <IoAdd
                size={28}
                className="cursor-pointer"
                onClick={handleAddForm}
              />
            )}
            <IoClose
              size={25}
              color="red"
              className="cursor-pointer"
              onClick={handleCreateForm}
            />
          </div>
        </div>
      )}

      {formList?.map((ele, idx) => {
        return (
          <div
            className={`w-full h-12 px-2 flex justify-between items-center cursor-pointer ${ele?.id === selectedForm?.id ? "border rounded" : ""}`}
            key={ele?.id}
            onClick={() => handleSelectForm(ele)}
          >
            <span>{ele?.name}</span>
            {ele?.id !== deleteId && (
              <IoClose
                className="cursor-pointer"
                onClick={(e) => handleDeleteForm(e, ele?.id)}
              />
            )}
            {deleteFormMutation.isLoading && ele?.id === deleteId && (
              <CuSpinner />
            )}
          </div>
        );
      })}
    </div>
  );
}
